// extracted by mini-css-extract-plugin
export default {"hideTooltip":"Z_-z","fadeIn":"__-z","delay":"aaa-z","recommendedSizeTooltip":"baa-z"};